// Collection page: sort, quick add, quick view, free shipping pill and "Show more".
// Adding to the bag goes through /cart/add.js, which the cart drawer listens for,
// so the drawer opens on its own after an add.
(function () {
  if (customElements.get('collection-lec')) return;

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '£{{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1]);
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  class CollectionLec extends HTMLElement {
    connectedCallback() {
      this.moneyFormat = this.dataset.moneyFormat;
      this.freeCents = parseInt(this.dataset.freeCents, 10) || 0;

      this.addEventListener('click', this.onClick.bind(this));

      var sort = this.querySelector('[data-cl-sort]');
      if (sort) sort.addEventListener('change', this.onSort.bind(this));

      this.qv = this.querySelector('[data-cl-qv]');
      this.onKeydown = this.onKeydown.bind(this);

      var self = this;
      document.addEventListener('shipping-progress:refresh', function () {
        self.refreshShipping();
      });
      document.addEventListener('cart-drawer:updated', function () {
        self.refreshShipping();
      });
    }

    onSort(event) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }

    onClick(event) {
      var add = event.target.closest('[data-cl-quick-add]');
      if (add) {
        event.preventDefault();
        this.quickAdd(add);
        return;
      }

      var view = event.target.closest('[data-cl-quick-view]');
      if (view) {
        event.preventDefault();
        this.openQuickView(view);
        return;
      }

      var next = event.target.closest('[data-cl-next]');
      if (next) {
        event.preventDefault();
        this.loadMore(next);
        return;
      }

      if (event.target.closest('[data-cl-qv-close]')) {
        this.closeQuickView();
        return;
      }

      var option = event.target.closest('[data-cl-qv-option]');
      if (option) {
        this.selectOption(option);
        return;
      }

      if (event.target.closest('[data-cl-qv-add]')) {
        this.addFromQuickView();
      }
    }

    addToCart(variantId) {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Error');
          return data;
        });
      });
    }

    quickAdd(button) {
      var self = this;
      var label = button.textContent;
      button.disabled = true;
      button.textContent = this.dataset.adding;
      this.addToCart(button.dataset.clQuickAdd)
        .then(function () {
          self.refreshShipping();
        })
        .catch(function () {
          window.alert(self.dataset.error);
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = label;
        });
    }

    refreshShipping() {
      var self = this;
      var pill = this.querySelector('[data-cl-ship]');
      if (!pill) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var text = pill.querySelector('[data-cl-ship-text]');
          if (!cart.item_count) {
            pill.hidden = true;
            return;
          }
          if (cart.total_price >= self.freeCents) {
            text.textContent = self.dataset.shipDone;
          } else {
            text.textContent = self.dataset.shipProgress.replace(
              '[amount]',
              formatMoney(self.freeCents - cart.total_price, self.moneyFormat)
            );
          }
          pill.hidden = false;
        })
        .catch(function () {});
    }

    /* Quick view */
    openQuickView(button) {
      var self = this;
      this.qvTrigger = button;
      button.disabled = true;
      fetch('/products/' + encodeURIComponent(button.dataset.clQuickView) + '.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Not found');
          return r.json();
        })
        .then(function (product) {
          self.renderQuickView(product, button.dataset.url);
        })
        .catch(function () {
          window.location.href = button.dataset.url;
        })
        .finally(function () {
          button.disabled = false;
        });
    }

    renderQuickView(product, url) {
      this.product = product;
      var variant =
        product.variants.find(function (v) {
          return v.available;
        }) || product.variants[0];
      this.selected = variant.options.slice();

      this.qv.querySelector('[data-cl-qv-title]').textContent = product.title;
      this.qv.querySelector('[data-cl-qv-link]').href = url;

      var optionsHtml = '';
      var self = this;
      product.options.forEach(function (option, index) {
        optionsHtml += '<fieldset class="cl-qv__group"><legend>' + escapeHtml(option.name) + '</legend><div class="cl-qv__options">';
        option.values.forEach(function (value) {
          optionsHtml +=
            '<button type="button" class="cl-qv__option" data-cl-qv-option data-index="' +
            index +
            '" data-value="' +
            escapeHtml(value) +
            '">' +
            escapeHtml(value) +
            '</button>';
        });
        optionsHtml += '</div></fieldset>';
      });
      this.qv.querySelector('[data-cl-qv-options]').innerHTML = optionsHtml;
      this.qv.querySelector('[data-cl-qv-error]').hidden = true;
      this.updateQuickView();

      this.qv.hidden = false;
      document.body.classList.add('cl-qv-open');
      document.addEventListener('keydown', this.onKeydown);
      var first = this.qv.querySelector('.cl-qv__option.is-active') || this.qv.querySelector('.cl-qv__close');
      if (first) first.focus();
      self.qv.querySelector('[role="dialog"]').scrollTop = 0;
    }

    currentVariant() {
      var selected = this.selected;
      return this.product.variants.find(function (v) {
        return v.options.every(function (value, i) {
          return value === selected[i];
        });
      });
    }

    selectOption(button) {
      this.selected[Number(button.dataset.index)] = button.dataset.value;
      this.updateQuickView();
    }

    updateQuickView() {
      var self = this;
      var variant = this.currentVariant();

      this.qv.querySelectorAll('[data-cl-qv-option]').forEach(function (btn) {
        var index = Number(btn.dataset.index);
        var active = self.selected[index] === btn.dataset.value;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        var test = self.selected.slice();
        test[index] = btn.dataset.value;
        var match = self.product.variants.find(function (v) {
          return v.options.every(function (value, i) {
            return value === test[i];
          });
        });
        btn.classList.toggle('is-unavailable', !match || !match.available);
      });

      var price = variant ? variant.price : this.product.price;
      this.qv.querySelector('[data-cl-qv-price]').textContent = formatMoney(price, this.moneyFormat);

      var image = (variant && variant.featured_image && variant.featured_image.src) || this.product.featured_image;
      var media = this.qv.querySelector('[data-cl-qv-media]');
      if (image) {
        var src = image.indexOf('?') > -1 ? image + '&width=600' : image + '?width=600';
        media.innerHTML = '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(this.product.title) + '" width="600" height="600">';
      } else {
        media.innerHTML = '';
      }

      var add = this.qv.querySelector('[data-cl-qv-add]');
      if (variant && variant.available) {
        add.disabled = false;
        add.textContent = this.dataset.addToBag;
      } else {
        add.disabled = true;
        add.textContent = this.dataset.soldOut;
      }
    }

    addFromQuickView() {
      var self = this;
      var variant = this.currentVariant();
      if (!variant || !variant.available) return;
      var add = this.qv.querySelector('[data-cl-qv-add]');
      var error = this.qv.querySelector('[data-cl-qv-error]');
      add.disabled = true;
      add.textContent = this.dataset.adding;
      error.hidden = true;
      this.addToCart(variant.id)
        .then(function () {
          self.closeQuickView(true);
          self.refreshShipping();
        })
        .catch(function (err) {
          error.textContent = (err && err.message && err.message !== 'Error') ? err.message : self.dataset.error;
          error.hidden = false;
        })
        .finally(function () {
          self.updateQuickView();
        });
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeQuickView();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.from(this.qv.querySelectorAll('button:not(:disabled), a[href]'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    closeQuickView(keepFocusFree) {
      if (!this.qv || this.qv.hidden) return;
      this.qv.hidden = true;
      document.body.classList.remove('cl-qv-open');
      document.removeEventListener('keydown', this.onKeydown);
      if (!keepFocusFree && this.qvTrigger) this.qvTrigger.focus();
    }

    /* Show more */
    loadMore(link) {
      var self = this;
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      link.classList.add('is-loading');
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);

      fetch(url.toString())
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = self.querySelector('[data-cl-grid]');
          var items = doc.querySelectorAll('[data-cl-grid] [data-cl-item]');
          items.forEach(function (item) {
            grid.appendChild(document.importNode(item, true));
          });

          var newNext = doc.querySelector('[data-cl-next]');
          var shownEl = self.querySelector('[data-cl-shown]');
          var newShown = doc.querySelector('[data-cl-shown]');
          if (shownEl && newShown) shownEl.textContent = newShown.textContent;
          var fill = self.querySelector('[data-cl-fill]');
          var newFill = doc.querySelector('[data-cl-fill]');
          if (fill && newFill) fill.style.width = newFill.style.width;

          if (newNext) {
            link.href = newNext.getAttribute('href');
            link.removeAttribute('aria-busy');
            link.classList.remove('is-loading');
          } else {
            link.remove();
          }

          var firstNew = items.length ? grid.querySelectorAll('[data-cl-item]')[grid.querySelectorAll('[data-cl-item]').length - items.length] : null;
          var focusTarget = firstNew && firstNew.querySelector('.cl-card__name');
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        })
        .catch(function () {
          window.location.href = link.href;
        });
    }
  }

  customElements.define('collection-lec', CollectionLec);
})();
